import {useUniversalFetch} from '#imports';

export function fetchSmsConsentCountries(): Promise<string[]> {
    return useUniversalFetch<string[]>('/api/feature-flipping/countries/transactional-sms-consent');
}
